export const LOGIN = "LOGIN"
export const UPDATE_USER = "UPDATE_USER"
export const LOGOUT = "LOGOUT"
export const START_LOADING = "START_LOADING"
export const STOP_LOADING = "STOP_LOADING"



// WEBPACK FOOTER //
// ./src/store/mutation-types.js